import React from "react";
import { Box } from "@mui/system";
import { DATA_BOXES } from "../../consts";

export const DataBox = ({ color, title }: { color: string; title: string }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }}
  >
    <div
      data-testid="color-box"
      style={{
        width: "21px",
        height: "21px",
        backgroundColor: color,
        borderRadius: "4px",
      }}
    />
    {title}
  </Box>
);

export const DataBoxesList = () => (
  <Box sx={{ display: "flex", gap: "32px", flexWrap: "wrap" }}>
    {DATA_BOXES.map(({ color, title }) => (
      <DataBox key={`${color}-${title}`} color={color} title={title} />
    ))}
  </Box>
);
